import React from "react";
import { CommentType } from "../../../../../dtos/CommentType";
import { GrantDto } from "../../../../../dtos/GrantDto";
import { StepDto } from "../../../../../dtos/StepDto";
import { useTaskFilesController } from "../hooks/useTaskFilesController";
import { SubTaskFilesView } from "./SubTaskFilesView";

export interface ITaskFilesProps {
    grant: GrantDto;
    step: StepDto;
    fileType: CommentType;
    canDownloadAll?: boolean;
    canDelete?: boolean;
    canView?: boolean;
    showHeader?: boolean;
    headerText?: string;
    showToolbar?: boolean;
    // Submission slot mode: token for the in-row upload/replace dialog's uploader.
    xsrfToken?: string;
}

export default function TaskFiles(props: ITaskFilesProps) {
    const ctrl = useTaskFilesController(props);
    return <SubTaskFilesView {...ctrl} />;
}
